import React, { useState, useRef, useEffect } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const hours = Array.from({ length: 12 }, (_, i) =>
  (i + 1).toString().padStart(2, "0")
);

const minutes = Array.from({ length: 60 }, (_, i) =>
  i.toString().padStart(2, "0")
);

const GlobalTimePicker = ({ value, onChange, placeholder = "Select Time" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
 useEffect(() => {
  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
  const [time, setTime] = useState({
    hour: "12",
    minute: "00",
    ampm: "AM",
  });

  // ✅ update when edit value comes
  useEffect(() => {
    if (value) {
      setTime(value);
    }
  }, [value]);

  const update = (newTime) => {
    setTime(newTime);
    onChange &&
      onChange(`${newTime.hour}:${newTime.minute} ${newTime.ampm}`);
  };

  return (
    <div className="gtp-wrapper" ref={ref}>
      <input
        className="input-main"
        readOnly
        value={`${time.hour}:${time.minute} ${time.ampm}`}
        placeholder={placeholder}
        onClick={() => setOpen(!open)}
      />

      {open && (
        <div className="gtp-dropdown">
          {/* Hour */}
          <div className="gtp-col">
            <button
              onClick={() =>
                update({
                  ...time,
                  hour: hours[(hours.indexOf(time.hour) + 11) % 12],
                })
              }
            >
              <KeyboardArrowUpIcon />
            </button>

            <div className="gtp-value">{time.hour}</div>

            <button
              onClick={() =>
                update({
                  ...time,
                  hour: hours[(hours.indexOf(time.hour) + 1) % 12],
                })
              }
            >
              <KeyboardArrowDownIcon />
            </button>
          </div>

          <div className="gtp-sep">:</div>

          {/* Minute */}
          <div className="gtp-col">
            <button
              onClick={() =>
                update({
                  ...time,
                  minute: minutes[(minutes.indexOf(time.minute) + 59) % 60],
                })
              }
            >
              <KeyboardArrowUpIcon />
            </button>

            <div className="gtp-value">{time.minute}</div>

            <button
              onClick={() =>
                update({
                  ...time,
                  minute: minutes[(minutes.indexOf(time.minute) + 1) % 60],
                })
              }
            >
              <KeyboardArrowDownIcon />
            </button>
          </div>

          {/* AM PM */}
          <div className="gtp-ampm">
            <button
              className={time.ampm === "AM" ? "active" : ""}
              onClick={() => update({ ...time, ampm: "AM" })}
            >
              AM
            </button>

            <button
              className={time.ampm === "PM" ? "active" : ""}
              onClick={() => update({ ...time, ampm: "PM" })}
            >
              PM
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalTimePicker;